import { emitter } from 'shared/helpers/mitt';
import analyticsHelper from 'dashboard/helper/AnalyticsHelper/index';

/**
 * Custom hook to track events
 */
export const useTrack = (...args) => {
  try {
    return analyticsHelper.track(...args);
  } catch (error) {
    // Ignore this, tracking is not mission critical
  }

  return null;
};

/**
 * Normalizes legacy and current toast options into one event payload.
 * @param {Object|null} options - Legacy action or new toast options.
 * @returns {{variant: string, action: Object|null}} Normalized toast metadata.
 */
const normalizeToastOptions = options => {
  if (!options) {
    return { variant: 'info', action: null };
  }

  if (
    options.variant ||
    Object.prototype.hasOwnProperty.call(options, 'action')
  ) {
    return {
      variant: options.variant || 'info',
      action: options.action || null,
    };
  }

  return {
    variant: 'info',
    action: options,
  };
};

/**
 * Emits a toast message event using a global emitter.
 * @param {string} message - The message to be displayed in the toast.
 * @param {Object|null} options - Optional toast options or legacy action object.
 */
export const useAlert = (message, options = null) => {
  const { variant, action } = normalizeToastOptions(options);
  emitter.emit('newToastMessage', { message, variant, action });
};
